import React from 'react'
import * as joda from '@js-joda/core'
import { Knob } from 'primereact/knob'
import { useCurrentTime } from '../_core/hooks'

type Props = {
  start:joda.Instant
  threshold:number
  max:number
}

const formatDurationNumeric = (x:joda.Duration) : string => {
  const seconds = x.get(joda.ChronoUnit.SECONDS)
  const pieces = [] as string[]
  if(seconds > 60)
  {
    const minutes = Math.floor(seconds / 60)
    pieces.push(`${minutes}`)
  }
  pieces.push(`:${seconds % 60}`)
  return pieces.join('')
}

export default React.memo((props:Props) => {
  const [stateCurrentTime,setCurrentTime] = React.useState(joda.Instant.now())
  useCurrentTime(setCurrentTime,300)
  const duration = joda.Duration.ofSeconds(props.start.until(stateCurrentTime,joda.ChronoUnit.SECONDS))
  return <Knob
    value={props.start.until(stateCurrentTime,joda.ChronoUnit.SECONDS)}
    valueColor={props.start.until(stateCurrentTime,joda.ChronoUnit.SECONDS) >= props.threshold ? '#198754' : '#BB2D3B'}
    min={0}
    max={props.max}
    rangeColor="#999"
    readOnly
    valueTemplate={formatDurationNumeric(duration)}
    className="position-absolute top-50 start-50 translate-middle bg-primary rounded-circle bg-opacity-25"
    size={70}
    textColor="white"
  />
})
